export const EXPIRED_CARD_WARNING = 'This card has expired. Please update.';
